import React from "react";
/**
 * Banners Context Instructions
 * Banners are managed by code change and deploy
 * 1. Update BannerContent and BannerContentMobile components below
 * 2. frontend/context/BannersContext.js set getBanners(true) to enable
 * 3. noun_project/notifications/models.py, add unique key to ACTIVE_BANNERS array
 *      (e.g. "HOLIDAY_SUB_PROMO_2022": {"show_anonymous": True},)
 *      Key can be anything we want as long as it is unique
 *      Once user closes banner, it will add to local storage so it does not show again for user
 *      Does not look like we set this up to support multiple banners at a given time.
 * Note: Not sure why, at one point I had to rebuild www for it to turn on locally.
 */

/*---------------------------
| Replace the following with Banner Content
---------------------------*/
const bannerLink =
    "/checkout/subscription/individual/payment/pro-yearly/?utm_source=np_home&utm_medium=banner&utm_campaign=holiday22";

// Tablet/Desktop Banner
const BannerContent = (
    <>
        🎁 Happy holidays! Get 20% off your first year of NounPro{" "}
        <a href={bannerLink}>with code HOLIDAY22</a>
    </>
);

// Mobile Banner
const BannerContentMobile = (
    <>
        🎁 Get 20% off your first year of NounPro{" "}
        <a href={bannerLink}>with code HOLIDAY22</a>
    </>
);

/**
 * getBanners
 * @param {Bool} enabled
 * @returns {Object} banners for mobile and tablet/desktop
 */
export const getBanners = (enabled = false) => {
    // nothing to see here by default
    let bannerContent = <></>;
    let bannerContentMobile = bannerContent;

    if (enabled) {
        bannerContent = BannerContent;
        bannerContentMobile = BannerContentMobile;
    }

    return {
        bannerContent,
        bannerContentMobile
    };
};
